/**
 * ConfirmDialog — destructive confirmation per UX §3.22 + AC-121.
 * Serif h3 title, body in caption muted, destructive primary + ghost cancel.
 * Destructive button label is the verb in plain form ("Delete", "Remove",
 * "Leave") per UX §4.4.
 */
import { Modal } from './Modal';
import { Button } from './Button';

export interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  /** Verb in plain form: "Delete", "Remove", "Leave" — never "Confirm". */
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void | Promise<void>;
  /** When true, the confirm button shows the hairline scrub. */
  loading?: boolean;
  /** Variant for the confirm button. Default 'destructive'. */
  variant?: 'destructive' | 'primary';
}

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  onConfirm,
  loading,
  variant = 'destructive',
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      size="sm"
    >
      <div className="mt-4 flex items-center justify-end gap-3">
        <Button variant="ghost" onClick={() => onOpenChange(false)}>
          {cancelLabel}
        </Button>
        <Button
          variant={variant}
          loading={loading}
          loadingLabel={`${confirmLabel}…`}
          onClick={() => {
            void onConfirm();
          }}
        >
          {confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
